"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _reactSlick = _interopRequireDefault(require("react-slick"));

require("slick-carousel/slick/slick.css");

require("slick-carousel/slick/slick-theme.css");

require("../../assets/slick-custom.css");

var _Carousel = require("./Carousel.style");

var _CarouselArrow = _interopRequireDefault(require("./CarouselArrow"));

var Carousel = function Carousel(_ref) {
  var arrows = _ref.arrows,
      children = _ref.children,
      responsive = _ref.responsive,
      slidesToShow = _ref.slidesToShow,
      rest = _objectWithoutProperties(_ref, ["arrows", "children", "responsive", "slidesToShow"]);

  var _ref2 = (0, _emotionTheming.useTheme)(),
      colors = _ref2.colors,
      carousel = _ref2.carousel;

  var settings = {
    arrows: arrows,
    className: '',
    dots: false,
    infinite: true,
    lazyLoad: true,
    slidesToShow: slidesToShow || 2,
    slidesToScroll: 1,
    nextArrow: /*#__PURE__*/_react.default.createElement(_CarouselArrow.default, {
      variant: "right",
      color: colors[carousel.arrowStrokeColor]
    }),
    prevArrow: /*#__PURE__*/_react.default.createElement(_CarouselArrow.default, {
      variant: "left",
      color: colors[carousel.arrowStrokeColor]
    }),
    centerMode: false,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: responsive[2] || 2,
        dots: false,
        centerMode: false
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: responsive[1] || 2,
        dots: false,
        centerMode: false
      }
    }, {
      breakpoint: 576,
      settings: {
        slidesToShow: responsive[0] || 1,
        dots: false,
        centerMode: true,
        centerPadding: '8%'
      }
    }]
  };
  return children && /*#__PURE__*/_react.default.createElement(_Carousel.Container, rest, /*#__PURE__*/_react.default.createElement(_reactSlick.default, settings, children));
};

Carousel.propTypes = {
  arrows: _propTypes.default.bool,
  children: _propTypes.default.node,
  responsive: _propTypes.default.arrayOf(_propTypes.default.number),
  slidesToShow: _propTypes.default.number
};
Carousel.defaultProps = {
  arrows: true,
  children: null,
  responsive: [2, 2, 1],
  slidesToShow: 2
};
var _default = Carousel;
exports.default = _default;